import JSXComponent from "../../dist/jsx-render/JSXComponent";

export interface IComponentProps {
    changeEvent?: (event: Event) => void;
}

export abstract class ComponentBase extends JSXComponent {
    constructor(props: IComponentProps) { super(props); }
    props: IComponentProps;

    abstract dispose();
    abstract validate();
    abstract render();
}